<jhi-spinner *ngIf="loading"></jhi-spinner>
<jhi-alert></jhi-alert>

<div class="container mt-4">
  <nav class="breadcrumb-container" aria-label="Percorso di navigazione">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a href="javascript:void(0)" (click)="goToHome()">Home</a><span class="separator">/</span></li>
      <li class="breadcrumb-item" *ngIf="checkNuovaIstanza()"><a href="javascript:void(0)" (click)="goToNuovaIstanza()">{{txtNuovaIst}}</a><span class="separator">/</span></li>
      <li class="breadcrumb-item active"><a href="javascript:void(0)">Istanze richieste</a></li>
    </ol>
  </nav>
</div>
<h4 class="fw-bold d-flex justify-content-center mt-3" jhiTranslate="istanze.istric">Istanze richieste</h4>
<form [formGroup]="formFilter" class="d-flex justify-content-end">
  <div class="d-flex justify-content-end container-fluid">
    <button class="btn btn-primary primary-button btn-icon" data-bs-toggle="dropdown">
      <svg class="icon icon-white ms-1">
        <use href="./content/svg/sprites.svg#it-funnel"></use>
      </svg>
      <span><span jhiTranslate="istanze.filtra.titolo">Filtra</span><span *ngIf="countFiltri != 0"> ({{ countFiltri }})</span></span>
    </button>
    <div class="dropdown-menu dismissible w-50" role="menu">
      <div class="container-fluid my-2">
        <div class="row justify-content-between mb-2">
          <div class="col">
            <h5 class="fw-bold">Filtra ricerca</h5>
          </div>
          <div class="col">
            <button type="button" class="btn-close float-end" data-bs-dismiss="menu"
                    aria-label="Chiudi avviso"></button>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-lg-6">
            <label for="dataInizio" jhiTranslate="istanze.filtra.dataIni">Data inizio</label>
            <input type="date" id="dataInizio" formControlName="dataInizio">
          </div>
          <div class="col-lg-6">
            <label for="dataFine" jhiTranslate="istanze.filtra.dataFin">Data fine</label>
            <input type="date" id="dataFine" formControlName="dataFine">
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-lg-6" formGroupName="istanza">
            <div formGroupName="stato">
              <label for="selectStato" jhiTranslate="istanze.stato">Stato</label>
              <div class="select-wrapper">
                <select id="selectStato" formControlName="descrizione">
                  <option selected="" value="">Tutti gli stati</option>
                  <option value="Bozza">Bozza</option>
                  <option value="Protocollata">Protocollata</option>
                  <option value="Da integrare">Da integrare</option>
                  <option value="Integrata">Integrata</option>
                  <option value="Evasa">Evasa</option>
                  <option value="Preso in carico">Preso in carico</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <label for="protocolloNumero">Protocollo numero</label>
            <input type="text" id="protocolloNumero" formControlName="protocolloNumero">
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-lg-6">
            <label for="protocolloNumero">Protocollo anno</label>
            <input type="number" id="protocolloAnno" formControlName="protocolloAnno">
          </div>
        </div>
      </div>
      <div class="container-fluid">
      <div class="row">
        <div class="col-lg-4 mb-1">
          <button class="btn btn-primary primary-button btn-xs btn-me w-100" type="button"
                  (click)="getIstanzaPageUser()">
            <span>Applica</span>
          </button>
        </div>
        <div class="col-lg-4 mb-1">
          <button class="btn btn-danger btn-xs btn-me w-100" type="button"
                  (click)="$event.stopPropagation();removeFilters()">
            <span>Rimuovi</span>
          </button>
        </div>
      </div>
      </div>
    </div>
  </div>
</form>

<form [formGroup]="formFilter">
  <div class="container-fluid my-2 text-center" style="min-height: 400px" *ngIf="this.istanze.length !== 0">
    <div class="card-wrapper mt-3 d-flex justify-content-center" style="padding-bottom: 0; ">
      <div class="card card-bg border-bottom-card background-primary-before" *ngIf="this.istanze != null">
        <div class="card-body">
          <div class="table-responsive ">
            <table class="table table-striped ">
              <caption hidden>Elenco istanze</caption>
              <thead>
              <tr>
                <th scope="col" jhiTranslate="istanze.dichiarante">Dichiarante</th>
                <th scope="col">Anno / numero protocollo</th>
                <th scope="col" jhiTranslate="istanze.descrizione">Descrizione</th>
                <th scope="col" jhiTranslate="istanze.data">Data</th>
                <th scope="col">Data massima evasione</th>
                <th scope="col" jhiTranslate="istanze.stato">Stato</th>
                <th scope="col">Esito</th>
                <th scope="col" jhiTranslate="istanze.azioni">Azioni</th>
              </tr>
              </thead>
              <tbody *ngIf="istanze.length">
              <tr *ngFor="let ist of istanze; index as i">
                <td *ngIf="!ist.id">-</td>
                <td *ngIf="ist.datiDichiarante">{{ist.datiDichiarante.nome}} {{ist.datiDichiarante.cognome}}</td>
                <td>{{ist.protocolloAnno ?? '-'}}/{{ist.protocolloNumero ?? '-'}}</td>
                <td class="mw-desc" *ngIf="ist.servizio.descrizione">{{ist.servizio.descrizione}}</td>
                <td class="mw-desc" *ngIf="!ist.servizio.descrizione">-</td>
                <td
                  *ngIf="ist.dtIstanza">{{formatDate(ist.dtIstanza).toLocaleString(this.selectedLanguage!.toString(), {
                  day: 'numeric',
                  month: 'long',
                  year: 'numeric'
                })}}</td>
                <td
                  *ngIf="ist.dataMassimaEvasione">{{formatDate(ist.dataMassimaEvasione.toString()).toLocaleString(this.selectedLanguage!.toString(), {
                  day: 'numeric',
                  month: 'long',
                  year: 'numeric'
                })}}</td>
                <td *ngIf="!ist.dtIstanza">-</td>
                <td *ngIf="!ist.dataMassimaEvasione">-</td>
                <td [ngClass]="ist.stato && ist.stato.descrizione ? mapStati.get(ist.stato.descrizione)?.colore : ''" *ngIf="!ist.stato.descrizione">
                -
                </td>
                <td [ngClass]="ist.stato && ist.stato.descrizione ? mapStati.get(ist.stato.descrizione)?.colore : ''" *ngIf="ist.stato.codice === '04' && ist.idPagamentoDovuto === null">
                Evasa
                </td>
                <td [ngClass]="ist.stato && ist.stato.descrizione ? mapStati.get(ist.stato.descrizione)?.colore : ''" *ngIf="ist.stato.codice === '04' && ist.idPagamentoDovuto !== null">
                Pagata
                </td>
                <td [ngClass]="ist.stato && ist.stato.descrizione !== '04' ? mapStati.get(ist.stato.descrizione)?.colore : ''" *ngIf="ist.stato.descrizione && ist.stato.codice !== '04'">{{ist.stato.descrizione}}</td>
                <td *ngIf="ist.tipoEsito?.descrizione != null">{{ ist.tipoEsito.descrizione }}</td>
                <td *ngIf="ist.tipoEsito?.descrizione === null || undefined">-</td>
                <td class="fw-bold">
                  <div>
                    <a title="Integra">
                      <svg class="icon icon-primary grow"
                           *ngIf="ist.stato.codice == '02' && ist.flIntAllegato"
                           (click)="getIntegrazione(ist.id)">
                        <use href="./content/svg/sprites.svg#it-files"></use>
                      </svg>
                    </a>
                    <a title="Paga"
                       *ngIf="ist.flIntPg && ist.stato.codice === '02' || ist.stato.codice === '04' && ist.flIntPg"
                       (click)="goToPagamento(ist.id)">
                      <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-primary grow" id="Icons"
                           viewBox="0 0 32 32">
                        <style type="text/css">
                          .st0 {
                            fill: none;
                            stroke: #06c;
                            stroke-width: 2;
                            stroke-linecap: round;
                            stroke-linejoin: round;
                            stroke-miterlimit: 10;
                          }

                          .st3 {
                            fill: none;
                          }
                        </style>
                        <path class="st0"
                              d="M19.7,26.8c-0.9-0.9-1.1-2.2-0.7-3.3l-3.3-3.3c-1.6-1.6-1.5-4.4,0.3-6.2l0,0l5,5"/>
                        <path class="st0" d="M12.7,26.3c0.6,0.7,1.3,1.3,2.1,1.7c0.7,0.4,1.2,1.2,1.2,2v0"/>
                        <path class="st0" d="M18,24H8c-1.1,0-2-0.9-2-2V5c0-1.1,0.9-2,2-2h10c1.1,0,2,0.9,2,2v13"/>
                        <line class="st0" x1="10" y1="3" x2="10" y2="24"/>
                        <line class="st0" x1="16" y1="6" x2="16" y2="10"/>
                        <path class="st0" d="M25,30v-9.5c0-3.3-2-6.2-5-7.4"/>
                        <rect x="-144" y="-216" class="st3" width="536" height="680"/>
                      </svg>
                    </a>
                    <a title="Modifica Bozza">
                      <svg class="icon icon-primary grow"
                           *ngIf="ist.stato.codice == '00'"
                           (click)="goToBozza(ist.servizio.cdServizio ?? '')">
                        <use href="./content/svg/sprites.svg#it-pencil"></use>
                      </svg>
                    </a>
                    <a title="Elimina Bozza">
                    <span data-bs-toggle="modal" data-bs-target="#modalDeleteIstanza"
                          (click)="setClickedIstanza(ist.id)"><svg class="icon grow"
                                                                   *ngIf="ist.stato.codice == '00'"><use
                      href="./content/svg/sprites.svg#it-delete"></use></svg></span>
                    </a>
                    <a title="Visualizza integrazioni">
                      <svg class="icon icon-primary grow"
                           *ngIf="ist.stato.codice !== '00'"
                           (click)="goToDettaglioIstanza(ist.id)">
                        <use href="./content/svg/sprites.svg#it-search"></use>
                      </svg>
                    </a>
                  </div>
                </td>
                <br *ngIf="windowSize <= 768">
              </tr>
              </tbody>
            </table>
            <div class="position-absolute end-0 mx-4 my-2 no-border">
              <div class="bootstrap-select">
                <label class="t-primary text-small" *ngIf="windowSize >= 768" jhiTranslate="pagina.elementi">Elementi
                  per pagina:</label>
                <select id="defaultSelect" formControlName="numEl" class="t-primary text-center" style="border: none">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </div>
            </div>
            <nav class="pagination-wrapper justify-content-center pagination-total"
                 aria-label="Esempio di navigazione responsive della pagina" *ngIf="istanze.length !== 0 && !loading">
              <ul class="pagination justify-content-center">
                <li class="page-item" [ngClass]="{'disabled c-normal': Isfirst === 'true'}">
                  <a class="page-link" (click)="paginaPrecedente()">
                    <svg class="icon icon-primary icon-color">
                      <use href="./content/svg/sprites.svg#it-chevron-left"></use>
                    </svg>
                    <span class="visually-hidden">Pagina precedente</span>
                  </a>
                </li>
                <li class="page-item d-none d-sm-flex" *ngFor="let p of [].constructor(Totalpages); index as i"
                    (click)="paginaCorrente != i ?vaiAPagina(i) : ''">
                  <a class="page-link"
                     [ngClass]="{'border primary-border text-color': paginaCorrente == i}">{{i + 1 }}</a>
                </li>
                <li class="page-item" [ngClass]="{'disabled c-normal': Islast === 'true'}">
                  <a class="page-link" (click)="paginaSuccessiva()">
                    <span class="visually-hidden">Pagina successiva</span>
                    <svg class="icon icon-primary icon-color">
                      <use href="./content/svg/sprites.svg#it-chevron-right"></use>
                    </svg>
                  </a>
                </li>
              </ul>
              <p jhiTranslate="pagina.items" [translateValues]="{ total: Totalelement }">Totale {{Totalelement}}
                elementi </p>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid text-center my-2" style="min-height: 400px" *ngIf="istanze.length == 0 && !loading">
    <div class="card-wrapper mt-3 d-flex justify-content-center" style="padding-bottom: 0; ">
      <div class="card card-bg border-bottom-card p-2 background-primary-before">
        <div style="margin-top: 4rem">
          <h3 class="fw-bold" style="margin-bottom: 3rem" jhiTranslate="istanze.titoloNoIstanze">Non ci sono
            istanze.</h3>
          <h4 jhiTranslate="istanze.sottotitoloNoIstanze">Al momento non sono state rilevate istanze.</h4>
        </div>
      </div>
    </div>
  </div>
</form>

<!-- Modal -->
<div class="modal fade" tabindex="-1" role="dialog" id="modalDeleteIstanza" aria-labelledby="modaleIstanza">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title h5 " id="modaleIstanza">
          <svg class="icon icon-warning pe-2">
            <use href="./content/svg/sprites.svg#it-warning-circle"></use>
          </svg>
          <span jhiTranslate="istanze.attenzione">Attenzione</span></h2>
      </div>
      <div class="modal-body">
        <p jhiTranslate="istanze.cancellaText">Confermi la cancellazione di quest'istanza?</p>
      </div>
      <div class="modal-footer">
        <button class="btn btn-danger btn-sm" data-bs-dismiss="modal" type="button" jhiTranslate="modale.annulla">
          Annulla
        </button>
        <button class="btn btn-success btn-sm" data-bs-dismiss="modal" type="button" (click)="eliminaIstanza()"
                jhiTranslate="modale.conferma">
          Conferma
        </button>
      </div>
    </div>
  </div>
</div>
